module.exports = "/images/tag_7e356b.png";